import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable()
export class GeneralConstants {

    private ALL_ACCESS_ACCOUNT_ID = 99;
    private INTERNAL_ACCOUNT_ID = 1009;

    private DEBOUNCE_TIME = 500;

    private ERROR_INFOHASH_EXISTS_MESSAGE = 'The given title is already present in the daily title infohash check table';
    private ERROR_QA_ALREADY_EXISTS_MESSAGE = 'The provided entry\'s already has a pending QA request';
    private GENOME_DATA_SUCCESS_MESSAGE = 'Successfully updated genome data';
    private SUBSCRIPTION_ALREADY_EXISTS_MESSAGE = 'Requested subscription already exist';
    private TITLE_REQUEST_ALREADY_EXISTS_MESSAGE = 'There already exists a request with the provided parrot id, link, or title, network and country';

    private NOT_CLAIMED_USER = 'not_claimed';
    private ALLOWED_EMPTY_GENES = ['genre_tags', 'also_known_as', 'wikibase_id', 'wiki_id', 'imdb_id', 'tmdb_id', 'tvdb_id', 'justwatch_id', 'the_numbers_id', 'production_company', 'distribution_company', 'end_date', 'ip_data', 'runtime_in_minutes', 'production_budget', 'others', 'characters', 'universes', 'date_of_birth', 'imdb_id', 'wiki_id', 'wikibase_id', 'tvdb_id', 'tmdb_id', 'justwatch_id', 'the_numbers_id', 'futon_critic_id', 'iqiyi_id', 'my_drama_list_id', 'prime_wire_id', 'reel_good_id', 'share_tv_id', 'simkl_id', 'trakt_tv_id', 'unogs_id', 'viu_id', 'wetv_id', 'yidio_id', 'netflix_id', 'amazon_prime_id', 'hbo_max_id', 'disney_plus_id', 'hulu_id', 'box_office_mojo_id', 'box_office_mojo_rl_id', 'viaf_id', 'freebase_id', 'omdb_person_id', 'google_knowledge_graph_id', 'eidr_id', 'instagram_id', 'facebook_id', 'twitter_id', 'birth_year', 'content_ratings', 'opening_weekend_theatre_count', 'release_info'];
    private CATALOG_STATES = ['demand_generation', 'requested', 'created', 'client_ready', 'data_collection', 'harvested' , 'metadata_ready'];

    // This key is limited to requests originating from the helpdesk
    private YOUTUBE_API_KEY = '';
    private YOUTUBE_API_URL = 'https://www.googleapis.com/youtube/v3/search';
    private YOUTUBE_MAX_RESULTS = 50;

    public getAllAccessAccountId() {
        return this.ALL_ACCESS_ACCOUNT_ID;
    }

    public getInternalAccountId() {
        return this.INTERNAL_ACCOUNT_ID;
    }

    public getDebounceTime() {
        return this.DEBOUNCE_TIME;
    }

    public getErrorInfohashExistsMessage() {
        return this.ERROR_INFOHASH_EXISTS_MESSAGE;
    }

    public getErrorQaAlreadyExistsMessage() {
        return this.ERROR_QA_ALREADY_EXISTS_MESSAGE;
    }

    public getGenomeDataSuccessMessage() {
        return this.GENOME_DATA_SUCCESS_MESSAGE;
    }

    public getSubscriptionAlreadyExistsMessage() {
        return this.SUBSCRIPTION_ALREADY_EXISTS_MESSAGE;
    }

    public getTitleRequestAlreadyExistsMessage() {
        return this.TITLE_REQUEST_ALREADY_EXISTS_MESSAGE;
    }

    public getNotClaimedUser() {
        return this.NOT_CLAIMED_USER;
    }

    public getAllowedEmptyGenes() {
        return this.ALLOWED_EMPTY_GENES;
    }

    public getCatalogStates() {
        return this.CATALOG_STATES;
    }

    public getYoutubeApiUrl() {
        return this.YOUTUBE_API_URL;
    }

    public getYoutubeMaxResults() {
        return this.YOUTUBE_MAX_RESULTS;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/general.constants.ts